import React, {useEffect, useState, useContext} from "react";
import useDebounce from "../../../Hooks/useDebounce";
import {FormInput} from "../../../Components/Form/Input/FormInput";
import {I18nReactContext} from "../../../contexts/I18nContext";
import {get} from "lodash";


/**
 * SearchFilter - Reusable search filter component with debouncing
 * 
 * @param {object} params - Component parameters
 * @param {object} params.filterModel - Filter model object containing search value
 * @param {function} params.setFilterModel - Function to update filter model
 * @param {string} params.label - Optional custom label (defaults to 'dataGrid.filters.search.input')
 * @param {string} params.placeholder - Optional placeholder text
 * @returns {JSX.Element} SearchFilter component
 */
export const SearchFilter = ({filterModel, setFilterModel, label, placeholder= ''}) => {
    const {i18n} = useContext(I18nReactContext);
    const [searchValue, setSearchValue] = useState(get(filterModel, 'filterValues.search', ''))
    const debouncedSearchValue = useDebounce({value: searchValue, delay: 500})

    /**
     * Effect hook to update the filter model when the debounced search value changes.
     * This ensures that the search filter is applied after a short delay,
     * preventing excessive re-renders or API calls during typing.
     *
     * @param {string} debouncedSearchValue - The debounced value of the search input.
     * @param {object} filterModel - The current filter model object.
     * @param {function} setFilterModel - Function to update the filter model.
     */
    useEffect(() => {
        let newFilterModel = {
            ...filterModel,
            filterValues: {
                ...filterModel.filterValues,
                search: debouncedSearchValue
            }
        }
        setFilterModel(newFilterModel)
    }, [debouncedSearchValue])

    /**
     * Handles the change event of the search input field.
     * Updates the local state with the new input value.
     *
     * @param {object} e - The event object from the input change.
     */
    const onSearchValueChange = (e) => {
        setSearchValue(e.target.value)
    }
    return <div className="searchFilter">
        <FormInput
            id="search-filter-input"
            label={label || i18n.translate('dataGrid.filters.search.input')}
            placeholder={placeholder}
            className={``}
            value={searchValue}
            onChange={onSearchValueChange}
        />
    </div>

}
